module.exports = __webpack_public_path__ + "img/badge-list-thumb-011.93bf57c3.png";